import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import FormControlContext from './FormControlContext'

import './FormControl.scss'

const FormControl = forwardRef(function FormControl(props, ref) {
	const { children, component: Component = 'div', ...other } = props

	const childContext = {}

	return (
		<FormControlContext.Provider value={childContext}>
			<Component ref={ref} className="Vb-formcontrol" {...other}>
				{children}
			</Component>
		</FormControlContext.Provider>
	)
})

FormControl.defaultProps = {
	component: 'div'
}

FormControl.propTypes = {
	/**
	 * The contents of the form control.
	 */
	children: PropTypes.node,
	/**
	 * The component used for the root node.
	 * Either a string to use a HTML element or a component.
	 * @default 'div'
	 */
	component: PropTypes.elementType
}

export default FormControl
